<script>
import layout from '@src/mixins/layout.vue'
import store from '@state/store'

export default {
  page: {
    title: 'Peer Coaching',
    meta: [{ name: 'description', content: 'The Peer Coaching page.' }],
  },
  mixins: [layout],
  data() {
    return {
      showWaitScreen: true,
      dialog: true,
      queueNumber: 5,
      chatMessage: '',
    }
  },
  mounted: function() {
    store.dispatch('chat/setChatDialogStatus', {
      component: 'Wait',
      dialog: true,
    })
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'safehaven-health-help' })
    },
  },
}
</script>

<template>
  <v-container>
    <v-row>
      <div class="pa-3">
        <v-row class="backButtonContainer">
          <v-img
            :src="require('@assets/images/safehaven/back.png')"
            height="10"
            width="10"
            class="ma-2"
          ></v-img>
          <a class="clickable primary--text" @click="goBack">Back</a>
        </v-row>
      </div>
    </v-row>
    <v-row>
      <v-col v-if="!notDesktop" cols="12" md="6" lg="6" xl="6">
        <v-img
          :src="require('@assets/images/safehaven/Secure-Chat.png')"
        ></v-img>
      </v-col>
      <v-col
        cols="12"
        sm="8"
        md="5"
        lg="4"
        xl="3"
        :align="notDesktop ? 'center' : 'start'"
        fill-height
      >
        <h3 class="peerHeading">Secure Chat In Progress</h3>
        <div :class="$style.text">
          You may browse the website while you wait for a response.
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.text {
  margin: 0.5rem auto;
  font-size: 15px;
  line-height: 22.5px !important;
  color: #2c3a4b;
}
.title {
  font-size: 28px;
  font-weight: 400;
}
.fullWidthBtn {
  width: 80%;
}

.dialogMenu {
  border-radius: 9px !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.dialogContainer {
  height: 600px;
  background-color: #f2f9ff !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.endSecureChatText {
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  color: #0476d9;
  text-align: right;
  letter-spacing: 0;
}

.chatContainer {
  height: 300px;
  margin-top: 25px;
}

.loaderContainer {
  margin: 0 auto;
}

.queueTextContainer {
  margin-top: 20px;
}

.queueText {
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0;
}

.queueNumberText {
  font-size: 60px;
  font-weight: 400;
  line-height: 90px;
  text-align: center;
  letter-spacing: 0;
}

.ownChatContainer {
  top: 337px;
  right: 13px;
  width: 308px;
  height: auto;
  padding: 15px;
  padding-bottom: 5px;
  margin-top: 10px;
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  color: #fff;
  text-align: left;
  white-space: normal;
  background: #0476d9;
  border: 1px solid #f4f6f9;
  border-radius: 7px;
  box-shadow: 1px 3px 5px rgba(4, 118, 217, 0.3);
}

.providerChatContainer {
  top: 188px;
  right: 13px;
  width: 308px;
  height: auto !important;
  padding: 15px;
  padding-bottom: 5px;
  margin-top: 10px;
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  color: #000;
  text-align: left;
  white-space: normal;
  background: #fff;
  border: 1px solid #f4f6f9;
  border-radius: 7px;
  box-shadow: 1px 3px 5px rgba(4, 118, 217, 0.3);
}

.footerContainer {
  padding-top: 20px;
  padding-bottom: 15px;
  background-color: #f2f9ff !important;
}

.attachmentIcon {
  width: 35px;
  height: 35px;
  padding-right: 10px;
  font-size: 30px;
}

.textAreaContainer {
  height: 50px;
  padding: 0;
  margin-right: 15px;
  background: #fff;
  border: 0.8px solid #a5abb3;
  border-radius: 5px;
}

@media screen and (max-width: 960px) {
  .fullWidthBtn {
    width: 90%;
  }
}
</style>

<style scoped>
.peerHeading {
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: -0.3px;
}

.appoinment {
  font-size: 18px !important;
  font-weight: 700;
  line-height: 22.5px !important;
}

.backButtonContainer {
  align-items: center;
  padding: 10px;
}
</style>
